/**
* 基础菜单 订单详情
*/
<template>
  <div class="contianer">
    <!-- 面包屑导航 -->
    <!-- <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>商品管理</el-breadcrumb-item>
        <el-breadcrumb-item @click.native="gotoGoodInfo()" class="pointer">商品基础信息管理</el-breadcrumb-item>
        <el-breadcrumb-item>查看详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div> -->
    <!-- 标签页 -->
    <div class="ml56">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="基本信息" name="first">
          <div class="flex_box mt20">
            <div class="content-left">
              <div class="item f14">
                <p class="color333">商品名称</p>
                <span class="color666">{{detailData.product_name}}</span>
              </div>
              <div class="item f14">
                <p class="color333">商品编号</p>
                <span class="color666">{{detailData.product_code}}</span>
              </div>
              <div class="item f14">
                <p class="color333">商品分类</p>
                <span class="color666">{{detailData.sortname1}}-{{detailData.sortname2}}-{{detailData.sortname3}}</span>
              </div>
              <div class="item f14">
                <p class="color333">商品品牌</p>
                <span class="color666">{{detailData.brand_name}}</span>
              </div>
              <div class="item f14">
                <p class="color333">商品类型</p>
                <span class="color666">{{detailData.productTypeName}}</span>
              </div>
              <div class="item f14">
                <p class="color333">是否为粉未液体</p>
                <span class="color666">{{detailData.liquid?'是':'否'}}</span>
              </div>
              <div class="item f14">
                <p class="color333">是否支持易燃易爆</p>
                <span class="color666">{{detailData.is_iae?'是':'否'}}</span>
              </div>
              <div class="item f14">
                <p class="color333">有效期</p>
                <span class="color666">{{detailData.product_expire}}</span>
              </div>
              <div class="item f14">
                <p class="color333">储运条件</p>
                <span class="color666">{{detailData.storage_cond}}</span>
              </div>
              <div class="item f14">
                <p class="color333">型号规格</p>
                <span class="color666">{{detailData.model}}</span>
              </div>
              <div class="item f14">
                <p class="color333">重量单位</p>
                <span class="color666">{{detailData.weight_unit==41?'千克(kg)':'克(g)'}}</span>
              </div>
              <div class="item f14">
                <p class="color333">包装单位</p>
                <span class="color666">{{detailData.pack_unit}}</span>
              </div>
              <div class="item f14">
                <p class="color333">注册证名称</p>
                <span class="color666">{{detailData.reg_name}}</span>
              </div>
              <div class="item f14">
                <p class="color333">注册证号</p>
                <span class="color666">{{detailData.reg_cert}}</span>
              </div>
              <div class="item f14">
                <p class="color333">注册证有效期</p>
                <span class="color666">{{detailData.reg_cert_expires}}</span>
              </div>
            </div>

            <div class="content-right">
              <div class="item f14">
                <p class="color333">审核状态</p>
                <span v-if="detailData.audit_status==260">审核中</span>
                <span v-else-if="detailData.audit_status==261">审核通过</span>
                <span v-else-if="detailData.audit_status==262">审核不通过</span>
                <span v-else>未提交</span>
              </div>
              <div class="item f14">
                <p class="color333">产品标准</p>
                <span class="color666">{{detailData.standard}}</span>
              </div>
              <div class="item f14" v-if="detailData.productTypeName!='药品'">
                <p class="color333">医械类别</p>
                <span class="color666">{{detailData.machine_type}}</span>
              </div>
              <div class="item f14">
                <p class="color333">适用范围</p>
                <span class="color666">{{detailData.scope}}</span>
              </div>
              <div class="item f14">
                <p class="color333">7天无理由退货</p>
                <span class="color666">{{detailData.days7?'是':'否'}}</span>
              </div>
              <div class="item f14">
                <p class="color333">可换货期限 (天)</p>
                <span class="color666">{{detailData.change_days}}</span>
              </div>
              <div class="item f14">
                <p class="color333">生产企业</p>
                <span class="color666">{{detailData.product_enterprise}}</span>
              </div>
              <div class="item f14">
                <p class="color333">禁忌症</p>
                <span class="color666">{{detailData.avoid}}</span>
              </div>
              <div class="item f14" v-if="detailData.productTypeName!='药品'">
                <p class="color333">医械类号</p>
                <span class="color666">{{detailData.machine_sort_no}}</span>
              </div>
              <div class="item f14">
                <p class="color333">包装方式</p>
                <span class="color666">{{detailData.pack}}</span>
              </div>
<!--              <div class="item f14">-->
<!--                <p class="color333 noRequired">销售/使用单位比</p>-->
<!--                <span class="color666">{{detailData.sale_use_rate}}</span>-->
<!--              </div>-->
              <div class="item f14">
                <p class="color333 noRequired">医保码</p>
                <span class="color666">{{detailData.med_code}}</span>
              </div>
              <div class="item f14">
                <p class="color333 noRequired">松佰标准编码</p>
                <span class="color666">{{detailData.standard_code}}</span>
              </div>
              <div class="item f14" v-for="(attr,index) in attrList" :key="index">
                <p class="color333 noRequired">{{attr.attr_name}}</p>
                <span class="color666">{{attr.attr_value}}</span>
              </div>

            </div>

          </div>
        </el-tab-pane>
        <el-tab-pane label="商品介绍(PC端)" name="second">
          <div class="demo-image__placeholder">
            <div v-if="indroducePCData.length">
              <div class="pc" v-for='(indroducePC,index) in indroducePCData' :key="index">
                <img class="img" :src="indroducePC.img_url">
              </div>
            </div>
            <div v-else>
              <img class="no-img" src="/static/img/no-img.png" alt="">
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="使用说明(PC端)" name="third">
          <div class="demo-image__placeholder">
            <div v-if="usePCData.length">
              <div class="pc" v-for='(usePC,index) in usePCData' :key="index">
                <img class="img" :src="usePC.img_url">
              </div>
            </div>
            <div v-else>
              <img class="no-img" src="/static/img/no-img.png" alt="">
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="商品介绍(移动端)" name="four">
          <div class="demo-image__placeholder">
            <div v-if="indroduceAPPData.length">
              <div class="app" v-for='(indroduceAPP,index) in indroduceAPPData' :key="index">
                <img class="img" :src="indroduceAPP.img_url">
              </div>
            </div>
            <div v-else>
              <img class="no-img" src="/static/img/no-img.png" alt="">
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="使用说明(移动端)" name="five">
          <div class="demo-image__placeholder">
            <div v-if="useAPPData.length">
              <div class="app" v-for='(useAPP,index) in useAPPData' :key="index">
                <img class="img" :src="useAPP.img_url">
              </div>
            </div>
            <div v-else>
              <img class="no-img" src="/static/img/no-img.png" alt="">
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
  import {productDetail} from '../../api/basisMG'
  import {param} from '../../api/commonMG'

  export default {
    data() {
      return {
        code: '',
        loading: false, //是显示加载
        listData: [], //用户数据
        detailData: {},
        indroducePCData: [],
        indroduceAPPData: [],
        usePCData: [],
        useAPPData: [],
        ProductType: [],
        sortName: '',
        brandName: '',
        activeName: 'first',
        arrays: [{src: 'https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg'}],
        attrList:[]
      }
    },

    /**
     * 创建完毕
     */
    created() {
      this.id = this.$route.query.id;
      this.sortName = this.$route.query.sortname1 + '-' + this.$route.query.sortname2 + '-' + this.$route.query.sortname3;
      this.brandName = this.$route.query.brand_name;
      if (this.$route.query.id) {
        localStorage.setItem('productId', this.$route.query.id)
        localStorage.setItem('sortName', this.sortName)
        localStorage.setItem('brandName', this.brandName)
        this.getdata(this.$route.query.id)
      }
    },
    mounted() {
      if (!this.id) {
        this.getdata(localStorage.getItem('productId'))
        this.sortName = localStorage.getItem('sortName')
        this.brandName = localStorage.getItem('brandName')
      }
      this.getParam('ProductType')
    },

    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      // 标签页
      handleClick(tab, event) {
        console.log(tab, event);
      },
      gotoGoodInfo() {
        localStorage.setItem('path', '/goods/GoodInfo')
        let tag = {
          url: "/goods/GoodInfo",
          menuname: "商品基础信息管理"
        }
        this.$store.commit('selectMenu', tag)
        this.$router.push({
          path: '/goods/GoodInfo'
        })
      },
      Formatter(value) {
        for (let item of this.ProductType) {
          if (item.code == value) {
            return item.name
          }
        }
      },
      getParam(type) {
        param(type)
          .then(res => {
            if (res.success) {
              if (type == 'ProductType') {
                this.ProductType = res.content;
              }
            }
          })
          .catch(err => {
          })
      },
      // 获取公司列表
      getdata(id) {
        this.loading = true
        productDetail(id)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.detailData = res.content.productBaseInfo;
              if(res.content.productBaseInfo.productAttrs){
                this.attrList = res.content.productBaseInfo.productAttrs;
              }
              if (Object.keys(res.content.productIntroduceInfo).length) {
                this.indroducePCData = res.content.productIntroduceInfo.indroduce;
                this.usePCData = res.content.productIntroduceInfo.use;
                this.indroduceAPPData = res.content.productIntroduceInfo.indroduceMobile;
                this.useAPPData = res.content.productIntroduceInfo.useMobile;
              }
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 点击复制
      copy(name, phone, addr) {
        let url = name + ',' + phone + ',' + addr;
        let oInput = document.createElement('input');
        oInput.value = url;
        document.body.appendChild(oInput);
        oInput.select(); // 选择对象;
        document.execCommand("Copy"); // 执行浏览器复制命令
        this.$message({
          message: '复制成功',
          type: 'success'
        });
        oInput.remove()
      },
    }
  }
</script>

<style scoped>
  .contianer {
    background: #fff;
    padding: 20px;
  }

  /deep/ .el-tabs__item.is-active {
    color: #409EFF;
    font-size: 20px;
    font-weight: 700;
    cursor: pointer;
  }

  .mt20 {
    margin-top: 20px;
  }

  .ml56 {
    margin-left: 56px;
  }

  .f14 {
    font-size: 14px;
  }

  .color333 {
    color: #333333;
  }

  .color666 {
    color: #666666;
  }

  .flex_box {
    display: flex;
  }

  .breadcrumb {
    margin-bottom: 15px;
  }

  .billing_item span {
    height: 40px;
    padding-left: 12px;
    padding-right: 15px;
    width: 300px;
    display: flex;
    align-items: center;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
  }

  .order_status .f20 {
    margin-top: 4px;
    color: #333;
    font-weight: 600;
  }

  .Delivery_warehouse .f20 {
    margin-top: 4px;
    color: #333;
    font-weight: 600;
  }

  .content-left,
  .content-right {
    width: 480px;
  }

  /deep/ .my-label {
    display: block;
    width: 152px;
    padding-right: 12px;
    text-align: right;
    color: #333333;
    lint-height: 22px;
  }

  /deep/ .my-content {
    width: 193px;
    color: #666666;
    lint-height: 22px;
  }

  /deep/ .el-descriptions-item__label.has-colon::after {
    margin-left: 14px;
  }

  .content-left {
    margin-right: 200px;
  }

  .item {
    width: 480px;
    margin-bottom: 16px;
    display: flex;
    word-wrap: break-word
  }

  .item p {
    width: 200px;
    line-height: 22px;
    text-align: right;
    margin-right: 12px;
  }

  .item p::after {
    content: '*';
    color: #F56C6C;
    margin: 0 4px;
  }

  .item p::before {
    content: ':';
    width: 6px;
    height: 6px;
    margin-right: 12px;
    float: right;
  }

  .item span {
    width: 328px;
    line-height: 22px;
  }

  .pc {
    width: 100%;
  }

  .pc img {
    width: 100%;
  }

  .app {
    width: 390px;
  }

  .app img {
    width: 100%;
  }
  .no-img {
    width: 550px;
    height: 258px;
    margin-top: 130px;
    margin-left: 190px;
    margin-bottom: 200px;
  }
  .item .noRequired::after {
    content: '';
    color: #F56C6C;
    margin: 0 4px;
  }
</style>





// WEBPACK FOOTER //
// src/views/goods/GoodInfoDetail.vue